import currentPayoutAccountReducer from 'modules/host-payout-methods/reducers/currentPayoutAccountReducer';
import payoutAccountsReducer from 'modules/host-payout-methods/reducers/payoutAccountsReducer';
import payoutMethodsPerCountryReducer from 'modules/host-payout-methods/reducers/payoutMethodsPerCountryReducer';
import payoutMethodsReducer from 'modules/host-payout-methods/reducers/payoutMethodsReducer';
import viewReducer from 'modules/host-payout-methods/reducers/viewReducer';
import Logger from 'utils/Logger';

import { State } from '../context/PayoutFormContext';
import { DispatchedActions } from './actions';

export default (state: State, action: DispatchedActions): State => {
  Logger.log(action.type, state, action);
  return {
    currentPayoutAccount: currentPayoutAccountReducer(
      state.currentPayoutAccount,
      action,
    ),
    payoutAccounts: payoutAccountsReducer(state.payoutAccounts, action),
    payoutMethods: payoutMethodsReducer(state.payoutMethods, action),
    payoutMethodsPerCountry: payoutMethodsPerCountryReducer(
      state.payoutMethodsPerCountry,
      action,
    ),
    view: viewReducer(state.view, action),
  };
};
